import './ETFFaq.sass';
import SlideToggle from 'react-slide-toggle';
import BezierEasing from 'bezier-easing';
import { useArticles } from '../api';

const bezier = BezierEasing(0.68, 0, 0.265, 1);

const ETFFaqCategory = (props) => {
	const { data } = props;
	const { articles } = useArticles(data.guid, data.route);

	return (
		<div className='ETFFaqCategory'>
			{articles.map((article, index) => {
				const { guid, title, contents } = article;

				return (
					<SlideToggle
						key={guid}
						duration={300}
						easeCollapse={bezier}
						easeExpand={bezier}
						collapsed={index !== 0}
						render={({ toggle, setCollapsibleElement, toggleState }) => {
							return (
								<div className={`faq slidetoggle ${toggleState}`}>
									<div className='toggle-target' onClick={toggle}>
										<div className='icon'></div>
										<div className='text'>{title}</div>
									</div>

									<div className='toggle-content' ref={setCollapsibleElement}>
										<div className='content' dangerouslySetInnerHTML={{ __html: contents }} />
									</div>
								</div>
							);
						}}
					/>
				);
			})}
		</div>
	);
};

export default ETFFaqCategory;
